import { ChevronRight } from "lucide-react";
import { Link } from "@/components/ui/link";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./breadcrumb.i18n";

export type BreadcrumbItem = {
  label: string;
  href?: string;
  onClick?: () => void;
};

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  const t = useT(T);
  return (
    <nav aria-label={t.label} className="flex items-center space-x-1 text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <div key={item.href ?? item.label} className="flex items-center">
            {index > 0 && <ChevronRight className="h-4 w-4 text-muted-foreground mx-1" />}
            {isLast ? (
              <span className="text-foreground font-medium">{item.label}</span>
            ) : item.onClick ? (
              <button
                type="button"
                onClick={item.onClick}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                {item.label}
              </button>
            ) : item.href ? (
              <Link
                to={item.href}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground font-medium">{item.label}</span>
            )}
          </div>
        );
      })}
    </nav>
  );
}
